/* MTM hero — brand red reference sphere being measured. Ported from approved comp. */
(function () {
  document.querySelectorAll('canvas.mtm-hero-canvas').forEach(function (canvas) {
    const ctx = canvas.getContext('2d');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    let W = 0, H = 0, DPR = 1, cx = 0, cy = 0, R = 0;

    const NLAT = 13, NLONG = 26;
    const lat = [];
    for (let i = 0; i <= NLAT; i++) {
      const phi = -Math.PI / 2 + Math.PI * (i / NLAT);
      const row = [];
      for (let j = 0; j <= NLONG; j++) {
        const th = 2 * Math.PI * (j / NLONG);
        row.push({ phi, th });
      }
      lat.push(row);
    }
    let cloud = [];
    function buildCloud() {
      cloud = [];
      const n = Math.min(150, Math.floor(W * H / 9000));
      for (let i = 0; i < n; i++) {
        cloud.push({ x: Math.random(), y: Math.random(), z: Math.random(), s: Math.random() * 1.4 + .3 });
      }
    }
    const TILT = -0.42;

    function resize() {
      const r = canvas.getBoundingClientRect();
      DPR = Math.min(window.devicePixelRatio || 1, 2);
      W = r.width; H = r.height;
      canvas.width = W * DPR; canvas.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      cx = W * 0.52; cy = H * 0.5;
      R = Math.min(W, H) * 0.32;
      buildCloud();
    }

    function project(phi, th, rot) {
      let x = Math.cos(phi) * Math.cos(th + rot);
      let y = Math.sin(phi);
      let z = Math.cos(phi) * Math.sin(th + rot);
      const yt = y * Math.cos(TILT) - z * Math.sin(TILT);
      const zt = y * Math.sin(TILT) + z * Math.cos(TILT);
      return { sx: cx + x * R, sy: cy - yt * R, depth: zt };
    }

    function draw(t) {
      ctx.clearRect(0, 0, W, H);
      const rot = t * 0.00016;

      for (const p of cloud) {
        const px = p.x * W, py = p.y * H;
        const tw = 0.35 + 0.3 * Math.sin(t * 0.001 + p.z * 12);
        ctx.fillStyle = 'rgba(112,104,104,' + (0.14 + 0.12 * tw) + ')';
        ctx.fillRect(px, py, p.s, p.s);
      }

      for (let k = 0; k < 3; k++) {
        const prog = ((t * 0.00007) + k / 3) % 1;
        const rr = R * (1.15 + prog * 1.55);
        const a = (1 - prog) * 0.30;
        ctx.beginPath();
        ctx.ellipse(cx, cy, rr, rr * 0.5, 0, 0, Math.PI * 2);
        ctx.strokeStyle = 'rgba(192,24,72,' + a + ')';
        ctx.lineWidth = 1;
        ctx.stroke();
      }

      const g = ctx.createRadialGradient(cx - R * 0.32, cy - R * 0.34, R * 0.05, cx, cy, R * 1.05);
      g.addColorStop(0, '#F7DBE2');
      g.addColorStop(0.16, '#D01858');
      g.addColorStop(0.5, '#C01848');
      g.addColorStop(0.82, '#7A1A3A');
      g.addColorStop(1, '#4A1528');
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2);
      ctx.fillStyle = g; ctx.fill();
      /* Rim now separates the sphere from a LIGHT field, so it reads dark. */
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2);
      ctx.strokeStyle = 'rgba(112,104,104,0.22)'; ctx.lineWidth = 1; ctx.stroke();

      for (let i = 1; i < NLAT; i++) {
        ctx.beginPath();
        let started = false;
        for (let j = 0; j <= NLONG; j++) {
          const p = project(lat[i][j].phi, lat[i][j].th, rot);
          ctx.globalAlpha = p.depth > 0 ? 0.5 : 0.12;
          if (!started) { ctx.moveTo(p.sx, p.sy); started = true; }
          else ctx.lineTo(p.sx, p.sy);
        }
        ctx.strokeStyle = 'rgba(244,242,237,0.6)';
        ctx.lineWidth = 0.8; ctx.stroke();
      }
      for (let j = 0; j < NLONG; j += 2) {
        ctx.beginPath();
        let started = false;
        for (let i = 0; i <= NLAT; i++) {
          const p = project(lat[i][j].phi, lat[i][j].th, rot);
          ctx.globalAlpha = p.depth > 0 ? 0.42 : 0.1;
          if (!started) { ctx.moveTo(p.sx, p.sy); started = true; }
          else ctx.lineTo(p.sx, p.sy);
        }
        ctx.strokeStyle = 'rgba(244,242,237,0.5)';
        ctx.lineWidth = 0.8; ctx.stroke();
      }
      ctx.globalAlpha = 1;

      const probes = 3;
      for (let m = 0; m < probes; m++) {
        const phi = Math.sin(t * 0.0004 + m * 2.1) * 0.9;
        const th = (t * 0.0006 + m * 2.094);
        const p = project(phi, th, rot);
        if (p.depth > 0) {
          ctx.strokeStyle = 'rgba(255,255,255,0.95)';
          ctx.lineWidth = 1.2;
          ctx.beginPath();
          ctx.moveTo(p.sx - 6, p.sy); ctx.lineTo(p.sx + 6, p.sy);
          ctx.moveTo(p.sx, p.sy - 6); ctx.lineTo(p.sx, p.sy + 6);
          ctx.stroke();
          ctx.beginPath(); ctx.arc(p.sx, p.sy, 2.4, 0, Math.PI * 2);
          ctx.fillStyle = '#FFFFFF'; ctx.fill();
        }
      }

      const hl = ctx.createRadialGradient(cx - R * 0.34, cy - R * 0.36, 0, cx - R * 0.34, cy - R * 0.36, R * 0.5);
      hl.addColorStop(0, 'rgba(255,255,255,0.35)');
      hl.addColorStop(1, 'rgba(255,255,255,0)');
      ctx.beginPath(); ctx.arc(cx, cy, R, 0, Math.PI * 2); ctx.fillStyle = hl; ctx.fill();
    }

    function resizeAndDraw() { resize(); draw(0); }
    window.addEventListener('resize', resizeAndDraw);
    resize();

    if (reduce) { draw(2400); return; }
    let raf, running = true;
    function loop(t) { if (!running) return; draw(t); raf = requestAnimationFrame(loop); }
    raf = requestAnimationFrame(loop);
    document.addEventListener('visibilitychange', function () {
      running = !document.hidden;
      if (running) raf = requestAnimationFrame(loop);
    });
  });
})();
